
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDJEYNRueziX9w18REC_6yxHRj7l1_unr8",
  authDomain:"iyanna-375f8.firebaseapp.com",
  projectId: "iyanna-375f8",
  storageBucket: "iyanna-375f8.firebasestorage.app",
  messagingSenderId:"393381911284", 
  appId: "1:393381911284:web:ae24a75c851c58b5e9dca1"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;